/*
 * des 特色资源头条稿
 * author lileilei
 * date 2018-01-17
 */
'use strict';
angular.module('resCenToutiaoModule', ['resCenToutiaoLeftModule', 'resCenToutiaoRouterModule', 'toutiaoQuickPreview'])
    .controller('resCenToutiaoCtrl', ['$scope', '$timeout', '$q', '$element', '$state', '$filter', '$stateParams', 'trsspliceString', 'modalDialog', 'trsHttpService', 'trsPrintService', 'storageListenerService', 'resCtrModalService', 'resourceCenterService',
        function($scope, $timeout, $q, $element, $state, $filter, $stateParams, trsspliceString, modalDialog, trsHttpService, trsPrintService, storageListenerService, resCtrModalService, resourceCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                // decode($stateParams.nodename); //将路由上面的参数解码为汉字参数
                $scope.page = {
                    'CURRPAGE': 1,
                    'ITEMCOUNT': '',
                    'PAGECOUNT': '',
                    'PAGESIZE': 20,
                };
                $scope.jumpToPageNum = 1;
                $scope.status = {
                    batchOperateBtn: {
                        'hoverStatus': ''
                    }
                };
                $scope.params = {
                    typeid: 'zyzx',
                    serviceid: 'toutiao',
                    modelid: 'findFromNavigation',
                    pageSize: $scope.page.PAGESIZE,
                    pageNum: '1',
                    media_id: $stateParams.nodeid,
                    keyword: {
                        keywords: '',
                        title: '',
                        content: '',
                        menuscriptType: '',
                        searchType: '0'
                    }
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    operFlags: []
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                listenStorage();
                initDropDown();
                if (angular.isDefined($scope.$root.backFilterData)) { // 判断是否有传递的数据
                    $scope.page = $scope.$root.backFilterData.page;
                    $scope.params.page = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.params.keyword = $scope.$root.backFilterData.keyword;
                    $scope.params.keyword.title = $scope.$root.backFilterData.keyword.title;
                    $scope.params.keyword.content = $scope.$root.backFilterData.keyword.content;
                    if (!!$scope.params.keyword.keywords) { // 当前检索词
                        if ($scope.$root.backFilterData.filterSelected.value == '0') {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[0]);
                        } else if ($scope.$root.backFilterData.filterSelected.value == '1') {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[1]);
                        } else {
                            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[2]);
                        }
                    }
                    // 设置日期
                    $scope.data.date = angular.copy(angular.isDefined($scope.$root.backFilterData.keyword.time) ? $scope.$root.backFilterData.keyword.time : '');
                    $scope.data.fromdate = $scope.data.date == '' ? undefined : $filter('date')($scope.data.date.split(',')[0], 'yyyy-MM-dd');
                    $scope.data.untildate = $scope.data.date == '' ? undefined : $filter('date')($scope.data.date.split(',')[1], 'yyyy-MM-dd');
                    var menuscriptType = $scope.$root.backFilterData.keyword.menuscriptType;
                    if (menuscriptType == '') { // 设置稿件类型
                        $scope.data.docTypeSelected = $scope.data.docType[0];
                    } else {
                        $scope.data.docTypeSelected = menuscriptType == '0' ? $scope.data.docType[0] : (menuscriptType == '1' ? $scope.data.docType[1] : $scope.data.docType[2]);
                    }
                    $scope.params.keyword = $scope.$root.backFilterData.keyword;
                    requestData();
                } else {
                    requestData();
                }
                $scope.$on('$destroy', function() {
                    delete $scope.$root.backFilterData;
                });
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                var params = angular.copy($scope.params);
                params.keyword = JSON.stringify(params.keyword);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    $scope.data.items = data.content;
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                    $scope.data.indexName = data.summary_info.indexName;
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'toutiaoDetail');
                    initOperFlag();
                    getImgList(data.content);
                });
            }

            /**
             * [initDropDown description] 初始化搜索下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                $scope.data.filterTypes = [{
                    name: '全部',
                    value: '0'
                }, {
                    name: '标题',
                    value: '1'
                }, {
                    name: '正文',
                    value: '2'
                }];
                $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[0]);
                $scope.data.docType = [{
                    name: '全部稿件',
                    value: '0'
                }, {
                    name: '文字',
                    value: '1'
                }, {
                    name: '图片',
                    value: '2'
                }];
                $scope.data.docTypeSelected = angular.copy($scope.data.docType[0]);
            }

            /**
             * [getFilterTimeVal description]检索下拉框回调
             * @return {[type]} [description]
             */
            $scope.getFilterVal = function() {
                $scope.params.keyword.searchType = $scope.data.filterTypeSelected.value;
                // $scope.$root.backFilterData.filterSelected = $scope.data.filterTypeSelected;
                // if ($scope.data.filterTypeSelected.value == '0') {
                //     $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                // } else if ($scope.data.filterTypeSelected.value == '1') {
                //     $scope.$root.backFilterData.keyword.title = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                //     $scope.$root.backFilterData.keyword.content = '';
                // } else {
                //     $scope.$root.backFilterData.keyword.content = $scope.$root.backFilterData.keyword.keywords = $scope.params.keyword.keywords;
                //     $scope.$root.backFilterData.keyword.title = '';
                // }
                // $scope.$root.backFilterData.keyword.searchType = $scope.data.filterTypeSelected.value;
            };

            /**
             * [searchWithKeyword description] 根据条件筛选稿件
             * @param  {[type]} key   [description] 筛选类型
             * @param  {[type]} value [description] 筛选内容
             * @return {[type]}       [description]
             */
            $scope.searchWithKeyword = function(key, value) {
                if (key == 'time') {
                    value = $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() ? $filter('date')($scope.data.fromdate, 'yyyy/MM/dd').toString() + ',' + $filter('date')($scope.data.untildate, 'yyyy/MM/dd').toString() : '';
                }
                $scope.params.keyword[key] = value;
                if (key == 'menuscriptType') {
                    $scope.params.keyword.menuscriptType = value.value;
                }
                $scope.params.pageNum = $scope.page.CURRPAGE = 1;
                $scope.data.items = [];
                requestData();
            };

            /**
             * [initOperFlag description] 初始化取签见撤重
             */
            function initOperFlag() {
                var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
                if (docIds) {
                    var params = {
                        methodname: 'queryFlag',
                        serviceid: 'mlf_bigdataexchange',
                        guids: docIds
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.operFlags = [];
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                    });
                }
            }

            /**
             * 请求图片数据
             * @param {Object} list
             */
            function getImgList(list) {
                var docIds = trsspliceString.spliceString(list, 'ZB_GUID', ',');
                if (docIds) {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'toutiao',
                        modelid: 'getImgList',
                        channelName: 'toutiao',
                        guids: docIds
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        if (data.result == 'success') {
                            var temp = data.content[0];
                            var arr = angular.copy(list);
                            for (var i = 0; i < arr.length; i++) {
                                var value = arr[i];
                                if (!value.imgurl) {
                                    value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                                    value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                                    value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                                }
                            }
                            if (!$scope.status.hasphoto) {
                                $scope.data.items = [];
                            }
                            // $timeout(function() {
                            if (!$scope.status.hasphoto) {
                                $scope.data.items = arr;
                                // initOperFlag();
                                findReprintCounts();
                            } else {
                                $scope.data.items = $scope.data.items ? $scope.data.items.concat(arr) : [].concat(arr);
                            }
                            // }, 0);
                        }
                    });
                }
            }

            /**
             * [findReprintCounts description] 获取转载量
             * @return {[type]} [description]
             */
            function findReprintCounts() {
                var tags = trsspliceString.spliceString($scope.data.items, 'MD5TAG', ',');
                if (!!tags) {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'jtcpg',
                        modelId: 'findReprintCounts',
                        tags: tags
                    };
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        // $timeout(function() {
                        for (var i = 0; i < $scope.data.items.length; i++) {
                            $scope.data.items[i].REPRINTS_COUNT = data.content[0][$scope.data.items[i].MD5TAG];
                        }
                        // });
                    });
                }
            }

            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description]
             * @param  {[type]} flagIndex [description]
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function(guid, flagIndex) {
                var temp = queryItemBYGUID(guid);
                if (!!temp) {
                    return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description]
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].GUID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
             * @param  {[type]} showRepeat [description]
             * @return {[type]}            [description]
             */
            $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            };

            /**
             * [openTakeDraftModal description] 取稿
             * @return {[type]} [description]
             */
            $scope.openTakeDraftModal = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'fetch',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    indexName: $scope.data.indexName,
                    channelName: 'toutiao',
                };
                var isOnlyOne = !($scope.data.selectedArray.length > 1);
                var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
                modalInstance.result.then(function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    });
                }, function() {

                    /* initOperFlag();
                    $scope.data.selectedArray = [];*/
                });
            };

            /**
             * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function takeDraftDownloadImgs(data) {
                var deferred = $q.defer();
                var needDownloadImg = false;
                for (var i = 0; i < data.REPORTS.length; i++) {
                    if (data.REPORTS[i].PICERROR == 1) {
                        needDownloadImg = true;
                        break;
                    }
                }
                if (needDownloadImg) {
                    resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }
            // 个人素材(稿件批量添加到个人素材)
            $scope.CreationAxis = function() {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'batchPersonalMaterial',
                    channelName: 'toutiao', // 栏目名称全拼结构
                    PersonalMaterialId: 0, // 所属文件夹ID，默认根节点（0）
                    indexName: $scope.data.indexName,
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('添加成功', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [openReserveDraftModal description] 预留稿件
             * @return {[type]} [description]
             */
            $scope.openReserveDraftModal = function() {
                var selectedArray = $scope.data.selectedArray;
                if (selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var resCtrModalServiceModal = resCtrModalService.reserveDraft(selectedArray);
                resCtrModalServiceModal.result.then(function(result) {
                    delete result.items;
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'delay',
                        guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                        indexName: $scope.data.indexName,
                        channelName: 'toutiao',
                    };
                    params = angular.extend(params, result);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    }, function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [collect description] 收藏稿件
             * @return {[type]} [description]
             */
            $scope.collect = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'collect',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    indexName: $scope.data.indexName,
                    channelName: 'toutiao',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [printBtn description] 打印稿件
             * @return {[type]} [description]
             */
            $scope.printBtn = function() {
                if ($scope.data.selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var params = {
                    'typeid': 'zyzx',
                    'serviceid': 'toutiao',
                    'modelid': 'detailData',
                    'indexName': $scope.data.indexName,
                    'channelName': 'toutiao',
                    'guid': trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    for (var i = 0; i < data.content.length; i++) {
                        data.content[i].updatetime = data.content[i].DOCPUBTIME;
                    }
                    trsPrintService.trsPrintRobot(data);
                    // $scope.data.selectedArray = [];
                });
            };

            /**
             * [export description] 导出稿件
             * @return {[type]} [description]
             */
            $scope.export = function() {
                if ($scope.data.selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportBigDataDocs',
                    GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                    indexName: $scope.data.indexName,
                    CHANNELNAMES: 'toutiao'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                    $scope.data.selectedArray = [];
                });
            };

            /**
             * [search description] 检索
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.search = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.filterTypeSelected.value == '1') {
                        $scope.params.keyword.title = $scope.params.keyword.keywords;
                        $scope.params.keyword.content = '';
                    } else if ($scope.data.filterTypeSelected.value == '2') {
                        $scope.params.keyword.title = '';
                        $scope.params.keyword.content = $scope.params.keyword.keywords;
                    } else {
                        $scope.params.keyword.title = $scope.params.keyword.keywords;
                        $scope.params.keyword.content = $scope.params.keyword.keywords;
                    }
                    $scope.page.CURRPAGE = $scope.jumpToPageNum = 1;
                    $scope.params.page = 1;
                    requestData();
                }
            };

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
             * [selectDoc description] 多选
             * @return {[type]} [description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.jumpToPageNum = $scope.page.CURRPAGE;
                $scope.data.selectedArray = [];
                requestData();
                resourceCenterService.scrollTop($element);
            };

            /**
             * [quickPreview description] 快速预览模式
             * @return {[type]} [description]
             */
            $scope.quickPreview = function() {
                $scope.params.keyword.title = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '1' ? $scope.params.keyword.keywords : '');
                $scope.params.keyword.content = $scope.data.filterTypeSelected.value == '0' ? $scope.params.keyword.keywords : ($scope.data.filterTypeSelected.value == '2' ? $scope.params.keyword.keywords : '');
                $scope.$root.filterData = {
                    page: $scope.page, // 分页
                    keyword: $scope.params.keyword, // 检索词
                    filterSelected: $scope.data.filterTypeSelected
                };
                $state.go('front.networksource.featuredresource.toutiao.quickpreview', $stateParams);
            };

            /**
             * [openPageForSearch description] 打开高级检索新页面
             * @return {[date]} [description]
             */
            $scope.openPageForSearch = function() {
                var url = $state.href('resadvancedsearch');
                window.open(url, '_blank');
            };
        }

    ]);
